import { produce } from 'immer';

import * as Types from './types';
import { getPeriod } from '../helpers';
import { actionTypes } from './constants';

const nowDate = new Date();

export const defaultState: Types.IBonusHistoryState = {
    bonuses: [],
    isLoading: true,
    error: '',
    statusFilter: 'all',
    fromDate: new Date(nowDate.setFullYear(nowDate.getFullYear() - 10)),
    toDate: new Date(),
    page: {
        pageId: '0',
        nextPageId: '0',
        isPageChanged: false
    }
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.TBonusHistoryAction): Types.IBonusHistoryState | void => {
        switch (action.type) {
            case actionTypes.UPDATE_HISTORY:
            case (actionTypes.UPDATE_HISTORY + reducerSuffix) as actionTypes.UPDATE_HISTORY: {
                const { bonuses: newBonuses, nextPageId } = action.payload;

                const bonuses = draftState.page.isPageChanged
                    ? [...draftState.bonuses, ...newBonuses]
                    : newBonuses;

                Object.assign(draftState, {
                    page: {
                        ...draftState.page,
                        isPageChanged: false,
                        nextPageId
                    },
                    isCancel: false,
                    bonuses
                });

                break;
            }

            case actionTypes.UPDATE_STATUS:
            case (actionTypes.UPDATE_STATUS + reducerSuffix) as actionTypes.UPDATE_STATUS: {
                Object.assign(draftState, {
                    statusFilter: action.payload,
                    page: {
                        ...draftState.page,
                        pageId: '',
                        nextPageId: '',
                        isPageChanged: false
                    }
                });

                break;
            }

            case actionTypes.UPDATE_PERIOD:
            case (actionTypes.UPDATE_PERIOD + reducerSuffix) as actionTypes.UPDATE_PERIOD: {
                const { fromDate, toDate } = getPeriod();

                Object.assign(draftState, {
                    page: {
                        ...draftState.page,
                        pageId: '',
                        nextPageId: '',
                        isPageChanged: false
                    },
                    fromDate,
                    toDate
                });

                break;
            }

            case actionTypes.UPDATE_PLAYABLE_GAME_TYPES:
            case (actionTypes.UPDATE_PLAYABLE_GAME_TYPES + reducerSuffix) as actionTypes.UPDATE_PLAYABLE_GAME_TYPES: {
                const { playableGameTypes, id, isLoading, error } = action.payload;
                const bonus = draftState.bonuses.find((item) => item.remoteBonusId === id);

                if (bonus) {
                    bonus.isLoading = isLoading;
                    bonus.error = error;
                    bonus.playableGameTypes = playableGameTypes;
                }

                break;
            }

            case actionTypes.LOAD_NEXT_PAGE:
            case (actionTypes.LOAD_NEXT_PAGE + reducerSuffix) as actionTypes.LOAD_NEXT_PAGE: {
                Object.assign(draftState, {
                    page: {
                        ...draftState.page,
                        pageId: draftState.page.nextPageId,
                        isPageChanged: true
                    }
                });

                break;
            }

            case actionTypes.TOGGLE_LOADING:
            case (actionTypes.TOGGLE_LOADING + reducerSuffix) as actionTypes.TOGGLE_LOADING: {
                Object.assign(draftState, {
                    isLoading: action.payload
                });

                break;
            }

            case actionTypes.SET_ERROR:
            case (actionTypes.SET_ERROR + reducerSuffix) as actionTypes.SET_ERROR: {
                const { error } = action.payload;

                Object.assign(draftState, {
                    error
                });

                break;
            }

            default: {
                break;
            }
        }
}, defaultState);
